import { render, staticRenderFns } from "./ChatBlockMobile.vue?vue&type=template&id=046b4588&"
import script from "./ChatBlockMobile.vue?vue&type=script&lang=js&"
export * from "./ChatBlockMobile.vue?vue&type=script&lang=js&"
import style0 from "./ChatBlockMobile.vue?vue&type=style&index=0&id=046b4588&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports